import { FC } from 'react';
import styles from './EmptyState.module.scss';
import { useSelector } from 'react-redux';
import { getUserInfo } from 'Store/Auth/Auth.selector';
import { PromptCard } from './Message';

const getFirstName = (name?: string) => {
  if (!name) {
    return '';
  }

  const containsSpace = name.includes(' ');
  if (!containsSpace) {
    return name;
  }

  const splitedName = name.split(' ');
  return splitedName[0];
};

export const EmptyState: FC<{ onSelectPrompt: (prompt: string) => void }> = ({
  onSelectPrompt
}) => {
  const userInfo = useSelector(getUserInfo);

  return (
    <div className={styles['Container']}>
      <div className={styles['ctaContainer']}>
        <div className={styles['badge']}>
          <span className={styles['badgeLabel']}>Assistente de IA</span>
        </div>

        <h1 className={styles['cta-title']}>
          Olá,{' '}
          <span className={styles['gradient-name']}>{getFirstName(userInfo?.Nome)}</span>!
          <span className={styles['subtitle']}>Como posso te ajudar hoje?</span>
        </h1>

        <p className={styles['paragrafo-prompt']}>
          Selecione um dos prompts abaixo ou digite sua pergunta para consultar projetos,
          tarefas e documentos:
        </p>
      </div>

      <div className={styles['footer']}>
        <PromptCard
          icon="calendar"
          title="Tarefas Semanais"
          description="“Quais tarefas estão atribuídas para mim esta semana?”"
          onClick={() =>
            onSelectPrompt('Quais tarefas estão atribuídas para mim esta semana?')
          }
        />
        <PromptCard
          icon="alerta"
          title="Prioridade Alta"
          description='"Liste todas as tarefas com prioridade alta"'
          onClick={() => onSelectPrompt('Liste todas as tarefas com prioridade alta')}
        />
        <PromptCard
          icon="disciplinaArquitetura"
          title="Filtro por Disciplina"
          description='"Listar tarefas pendentes por disciplina"'
          onClick={() => onSelectPrompt('Listar tarefas pendentes por disciplina')}
        />
        <PromptCard
          icon="relogio"
          title="Tarefas em Atraso"
          description='"Tem alguma tarefa em atraso para o meu time?"'
          onClick={() => onSelectPrompt('Tem alguma tarefa em atraso para o meu time?')}
        />
      </div>
    </div>
  );
};